export const BUILD_VERSION = '1782396939';
